
import { Options, Vue } from 'vue-class-component';
import CookieConsent from '@/components/CookieConsent/CookieConsent.vue';
import Toast from '@/components/Toast/Toast.vue';
import WarningPortrait from '@/components/WarningPortrait/WarningPortrait.vue';
import Tutorial from "@/components/Tutorial/Tutorial.vue";

@Options({
    components: {
        CookieConsent,
        Toast,
        WarningPortrait,
        Tutorial,
    }
})
export default class MainLayout extends Vue {
    mounted() {
        // Set a timeout...
        setTimeout(function(){
            // Hide the address bar!
            window.scrollTo(0, 1);
        }, 10);
    }
}
